<!--  -->
<template>
<div class='container'>
    <img src="../../assets/image/finish_get.png" alt="">
    <div class="hint_one">支付成功</div>
    <div class="hint_two">恭喜！您所报名的课程已缴费 成功，请留意课程开班状态，准时 参与课程培训</div>
    <button class="goHome" @click="goIndex">返回首页    {{code}}</button>
    <button class="lookClass" @click="goClass">查看课程</button>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    code:"",
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    goIndex(){
        this.$router.push({ path: "/" });
    },
    goClass(){
        this.$router.push({ path: "/" });
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    // let token = localStorage.getItem('token')
    let str = location.href,
    num = str.indexOf("?");
    str = str.substr(num + 1); 
    let arr = str.split("&"); 
    var code = arr[1].split('=')[1]
    // var moneys = arr[0].split('=')[1]
    this.code = code
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container{
    width: 100%;
    height: 100vh;
    background-color: #fff;
    overflow: hidden;
    text-align: center;
    img{
        width: 88px;
        height: 88px;
        margin-top: 57px;
    }
    .hint_one{
        font-size: 21px;
        color: #333333;
        font-weight: 500;
        margin-top: 21px;
    }
    .hint_two{
        width: 45%;
        text-align: center;
        font-size: 14px;
        color: #666666;
        margin:24px auto 0;
    }
    .know{
        width: 139px;
        height: 42px;
        border-radius: 21px;
        line-height: 42px;
        background-color: #fff;
        border: 1px solid #2F85ED;
        font-size: 17px;
        color: #2F85ED;
        margin-top: 82px;
    }
    .goHome{
        width: 35%;
        height: 42px;
        border-radius: 21px;
        line-height: 42px;
        background-color: #fff;
        border: 1px solid #a6a6a6;
        font-size: 17px;
        color: #333333;
        margin-top: 82px;
        float: left;
        margin-left: 10%;
    }
    .lookClass{
        width: 35%;
        height: 42px;
        border-radius: 21px;
        line-height: 42px;
        background-color: #fff;
        border: 1px solid #a6a6a6;
        font-size: 17px;
        color: #333333;
        margin-top: 82px;
        float: right;
        margin-right: 10%;
    }
}

</style>